import { HTMLAttributes, memo } from "react";
import Icon from "../../Elements/Icon/Icon";

interface SidePanelButtonI extends HTMLAttributes<HTMLDivElement> {}

/**
 * Represents a reusable side panel button component
 * which expands and collapses the side panel.
 */
const SidePanelButton = memo(
  ({ onClick, className, ...rest }: SidePanelButtonI) => {
    return (
      <div
        className={`side-panel-button ${className || ""}`}
        onClick={onClick}
        {...rest}
      >
        <Icon name="arrow-left-datepicker" />
      </div>
    );
  }
);

export default SidePanelButton;
